export enum ContentVersionSource {
    Sprint = 1,
    Buzz = 2,
    Shreq = 3,
    Trailer = 4
}
